import React from "react";
import { Box, Typography } from "@mui/material";
import Cards from "./Cards";

export default function Container() {
  // Common styles for Typography components
  const commonTypographyStyles = {
    alignSelf: "stretch", // Stretch to fill the container
    color: "var(--Tokens-Text-Primary, #3A3A3A)", // Text color with fallback
    textAlign: "center", // Center text alignment
    fontFeatureSettings: "'liga' off, 'clig' off", // Disable ligatures and contextual forms
    fontFamily: "var(--Typography-Font-Family-Heading, Inter)", // Font family with fallback
  };

  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        padding: "32px",
        minHeight: "80vh",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "16px", // Using the fallback value directly
        flexShrink: 0,
        borderRadius: "8px", // Small corner radius
        backgroundColor: "var(--Tokens-Background-Default, #F3F7FD);", // Background color with fallback
      }}
    >
      <Typography
        sx={{
          ...commonTypographyStyles, // Spread common styles
          fontSize: "var(--Font-Size-H2, 32px)", // Specific font size for h2
          fontWeight: 700, // Bold font weight
          lineHeight: "var(--Line-Height-H2, 44px)", // Line height with fallback
        }}
        variant="h2" // Use the h2 variant for semantic HTML and default styles
      >
        Welcome to PepsiCo Agriculture Headquarters
      </Typography>

      <Cards />
    </Box>
  );
}
